import {
  SET_AUTH_CONNECTIONS,
  SET_REFERENCES,
  SET_USER_VISIBLE_COLUMNS,
  REPLACE_CONNECTION,
  ADD_CONNECTION
} from './mutationTypes';

import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';


export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_AUTH_CONNECTIONS](state, authenticationConnections) {
    state.authConnections = authenticationConnections;
  },
  [SET_REFERENCES](state, references) {
    state.references = references;
  },
  [SET_USER_VISIBLE_COLUMNS](state, userVisibleColumns) {
    state.userVisibleColumns = userVisibleColumns;
  },
  [ADD_CONNECTION](state, connection) {
    state.authConnections = [...state.authConnections, connection];
  },
  [REPLACE_CONNECTION](state, authenticationConnection) {
    const index = state.authConnections.findIndex(u => u.id == authenticationConnection.id);
    if (index >= 0) {
      state.authConnections.splice(index, 1, authenticationConnection);
    }
  },
};